import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  itemContainer: {
    alignItems: 'center',
  },
  itemIcon: {
    height: 32,
    width: 32,
    borderRadius: 16,
  },
  itemContent: {
    width: '90%',
    marginLeft: 17,
    marginVertical: 5,
  },
});
